import { Modal } from "react-bootstrap";
import "../Bid.css";
const FaqModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} size="md">
      <Modal.Header closeButton>
        <Modal.Title className="faq-ask-que">
          Frequently Asked Questions
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="faq-content px-4" style={{ color: "#333" }}>
          <div className="faq-item mb-4">
            <h6>Q. What is a 'bid deposit'?</h6>
            <div className="answer-wrapper">
              <p>
                <span className="answer-prefix">A.</span> The bid deposit is a
                hold placed on your credit card before you can place a bid on
                applicable properties on Hubzu. This is used to verify that you
                are a serious bidder with intent to purchase the property.
                Please keep in mind, the bid deposit hold is required once for
                every applicable property in order to place a bid on said
                property.
              </p>
            </div>
          </div>

          <div className="faq-item mb-4">
            <h6>Q. Why is there a bid deposit hold?</h6>
            <div className="answer-wrapper">
              <p>
                <span className="answer-prefix">A.</span> The bid deposit hold
                is one of the steps we take to help ensure that the bidding pool
                is comprised of serious bidders.
              </p>
            </div>
          </div>

          <div className="faq-item mb-4">
            <h6>Q. Is the bid deposit refundable?</h6>
            <div className="answer-wrapper">
              <p>
                <span className="answer-prefix">A.</span> The bid deposit is a
                hold placed on your credit and not a charge, unless you fail to
                fulfill certain obligations if you are chosen as the bidder to
                proceed with the transaction. If you are not the selected
                bidder, the hold will be removed within 4-7 business days after
                the auction cycle has ended. If you are the selected bidder, the
                bid deposit will be released once we receive confirmation from
                the third-party escrow agent that your earnest money deposit (or
                EMD) was received within the time frame set forth in the
                purchase and sale agreement. If you are the selected bidder and
                you fail to deliver your earnest money deposit within the
                required time frame, the hold will be converted into an actual
                charge on your credit card in the amount of the bid deposit.
              </p>
            </div>
          </div>

          <div className="faq-item mb-4">
            <h6>Q. How long is the bid deposit hold?</h6>
            <div className="answer-wrapper">
              <p>
                <span className="answer-prefix">A.</span> The bid deposit hold
                will remain in place for the duration of the auction cycle. Once
                the auction cycle ends, one bidder may be chosen by the seller
                as the "selected bidder" to proceed to contract. If you are the
                selected bidder, the bid deposit will be released once we
                receive confirmation from the third-party escrow agent that your
                earnest money deposit (or EMD) was received within the required
                time frame. If you are not the selected bidder, the hold will be
                removed within 4-7 business days after the auction cycle has
                ended.
              </p>
            </div>
          </div>

          <div className="faq-item mb-4">
            <div className=" d-flex ">
              <div>Q.</div>
              <h6>
                {" "}
                There's already a bid deposit hold on my credit card for a
                property. If I bid on another property, is a new bid deposit
                hold required?
              </h6>
            </div>

            <div className="answer-wrapper">
              <p>
                <span className="answer-prefix">A.</span> Yes, a bid deposit
                hold is required once for every applicable property in order to
                place a bid on that property.
              </p>
            </div>
          </div>

          <div className="faq-item mb-4">
            <div className=" d-flex ">
              <div> Q. </div>
              <h6>
                Can I withdraw the bid deposit hold anytime during the auction
                cycle?
              </h6>{" "}
            </div>

            <div className="answer-wrapper">
              <p>
                <span className="answer-prefix">A.</span> No. Once the bid
                deposit hold is placed, the amount will be held through the end
                of the auction cycle, even if you do not place any bids on that
                property in the auction cycle. Please be sure that you want to
                place a bid on a property before you complete the bid deposit
                process.
              </p>
            </div>
          </div>

          <div className="faq-item mb-4">
            <div className=" d-flex">
              <div>Q.</div>
              <div>
                <h6>
                  What if I am the selected bidder and don't make the earnest
                  money deposit?
                </h6>
              </div>
            </div>

            <div className="answer-wrapper">
              <p>
                <span className="answer-prefix">A.</span> If you are the
                selected bidder and you fail to deliver your earnest money
                deposit within the required time frame, the hold will be
                converted into a non-refundable charge on your credit card in
                the amount of the bid deposit.
              </p>
            </div>
          </div>

          <div className="faq-item mb-4">
            <h6>Q. What is the $0.50 non-refundable verification charge?</h6>
            <div className="answer-wrapper">
              <p>
                <span className="answer-prefix">A.</span> The one-time
                non-refundable $0.50 charge is another mechanism used to verify
                your intent as a serious bidder with the intent to purchase the
                property if your bid is ultimately selected.
              </p>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FaqModal;
